export default "__VITE_ASSET__Dz764Zhq__"